export default {
  reset: (state) => {
    state.item = {
      course: null,
      tag: null,
      code: null,
      days: null,
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
